import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { startConsentListener, trackPageView } from '../../../services/analytics/analytics';

const RouteTracker: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    trackPageView(pathname);
  }, [pathname]);

  useEffect(() => startConsentListener(), []);

  return null;
};

export default RouteTracker;
